import { connect } from 'react-redux'
import at from 'lodash/at'
import WorkOrderCard from '../../components/data-card/work-order-card'

import { deleteWorkOrder } from '../../actions/work-orders'

const mapStateToProps = (state, ownProps) => {
  const workOrder = state.workOrders[ownProps.workOrderId]
  const technicians = at(state.users, workOrder.technicians)

  return {
    ...workOrder,
    technicians,
    location: state.locations[workOrder.location]
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    deleteWorkOrder (workOrderId) {
      dispatch(deleteWorkOrder(workOrderId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderCard)



// WEBPACK FOOTER //
// ./src/containers/work-orders/work-order-card-container.js